
    import utils from '@/utils';
    import DataHelperSingleton from "@/store/DataHelperSingleton";
    import Sortable from 'sortablejs';
    import { Component, Vue ,Provide} from 'vue-property-decorator';

    @Component
    export default class CtrlCVtoexcel extends Vue {
        $store: any;
        $router: any;
        sortable: any;
        $FileSaver: any;
        $XLSX: any;
        $confirm: any;
        @Provide() tabelHeight: number = window.innerHeight;
        @Provide() isRouterAlive = true;
        @Provide() list: any = [];
        @Provide() teacherList: any[] = [];
        @Provide() valueTime?: any = "";
        @Provide() sumCount= 0;
        @Provide() ifsc=true;
        @Provide() Col = [{
						label: "导师",
						prop: "teacherName",
						width: "200",
						isTrue: true,
                        fixed:true
					},
					{
						label: "付款方式",
						prop: "fukuanfangshi",
						width: "200",
						isTrue: true,
                        fixed:true
					},
					{
						label: "账号信息",
						prop: "xinxi",
						width: "200",
						isTrue: true,
                        fixed:false
					},
					{
						label: "账号姓名",
						prop: "name",
						width: "200",
						isTrue: true,
                        fixed:false
					},
					{
						label: "薪水额度",
						prop: "price",
						width: "200",
                        isTrue: true,
						fixed:false
					}
				];

        @Provide() dropCol = [{
						label: "导师",
						prop: "teacherName",
						width: "200",
						isTrue: true,
                        fixed:true
					},
					{
						label: "付款方式",
						prop: "fukuanfangshi",
						width: "200",
						isTrue: true,
                        fixed:true
					},
					{
						label: "账号信息",
						prop: "xinxi",
						width: "200",
						isTrue: true,
                        fixed:false
					},
					{
						label: "账号姓名",
						prop: "name",
						width: "200",
						isTrue: true,
                        fixed:false
					},
					{
						label: "薪水额度",
						prop: "price",
						width: "200",
                        isTrue: true,
						fixed:false
					}
				];

            /**
             * @description: 将支付宝批量付款信息全部导出至excel文件中
             * @return void
             */
            export2Excel(): void{
                this.$confirm('确认导出Excel吗。', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'success'
                }).then(() => {
                    let tables = document.getElementById("out-table");
                    let table_book = this.$XLSX.utils.table_to_book(tables);
                    var table_write = this.$XLSX.write(table_book, {
                        bookType: "xlsx",
                        bookSST: true,
                        type: "array"
                    });
                    try {
                        this.$FileSaver.saveAs(
                        new Blob([table_write], { type: "application/octet-stream" }),
                        "alipaySalary.xlsx"
                        );
                    } catch (e) {
                        if (typeof console != "undefined") console.log(e, table_write);
                    }
                    return table_write;
                });
            }

        /**
         * @description: 范围查询
         * @return void
         */
        selectData(): void{            
            if (this.valueTime == null || this.valueTime.length != 2) {
                    this.onload();
                } else {
                    //查询信息
                    utils.requestPost("查询支付方式为支付宝的教师信息",
                        "sale/searchselect", {
                        classStartName: utils.getDetailTime(this.valueTime[0], 4),
                        classEndName: utils.getDetailTime(this.valueTime[1], 4)
                    }
                    ).then((data) => {
                        utils.getUSDExchangeRate().then((rate: any) => {
                            for (let i = 0; i < data.length; i++) {
                                if (data[i].cid.classActualDuration != '')
                                    if (data[i].tid.types == 'CNY') {
                                        data[i].tid.teacherRatePayCNY = (data[i].tid.teacherRate * data[i].cid.classActualDuration /
                                            60)
                                            .toFixed(
                                                2);
                                    } else {
                                        data[i].tid.teacherRatePayCNY =  (data[i].tid.teacherRate * data[i].cid.classActualDuration *
                                            rate / 60).toFixed(
                                                2);
                                    }
                            }
                            this.list = data;
                        
                            //导师查询后，对付款方式筛选， 筛选条件为支付宝
                            const teacherList = [];
                            for (let i = 0; i < this.list.length; i++) {
                                if (JSON.stringify(teacherList).indexOf((this.list[i].tid.teacherName)) == -1) {
                                    if (this.list[i].tid.teacherPay == '支付宝')
                                        teacherList.push({
                                            teacherName: this.list[i].tid.teacherName,
                                            types: this.list[i].tid.types,
                                            price: 0,
                                            xinxi: this.list[i].tid.userInformation,
                                            fukuanfangshi: this.list[i].tid.teacherPay,
                                            name: this.list[i].tid.userName,
                                        });
                                }
                        
                            }
                                         
                            let sumCount = 0;
                            for (let i = 0; i < teacherList.length; i++) {
                                for (let c= 0; c < this.list.length; c++) {
                                    if (teacherList[i].teacherName == this.list[c].tid.teacherName) {
                                        if (this.list[c].tid.teacherRatePayCNY != undefined) {
                                            teacherList[i].price += parseFloat(this.list[c].tid.teacherRatePayCNY);
                                            sumCount += parseFloat(this.list[c].tid.teacherRatePayCNY);
                                        }
                                    }
                                }
                                teacherList[i].price = Number(parseFloat(String(teacherList[i].price)).toFixed(2));
                            }
                        
                            this.sumCount = Number(parseFloat(String(sumCount)).toFixed(2));
                            this.teacherList = teacherList;
                        })
                    })
                }
        }
        /**
         * @description: 导师支付基本信息数据的渲染
         * @return void
         */
        onload(): void{
                //查询信息
                utils.requestGet("查询导师支付基本信息",
                    "sale/selectpay", null
                ).then((data: any) => {

                    utils.getUSDExchangeRate().then((rate: any) => {
                        for (let i = 0; i < data.length; i++) {
                            if (data[i].cid.classActualDuration != '')
                                if (data[i].tid.types == 'CNY') {
                                    data[i].tid.teacherRatePayCNY = (data[i].tid.teacherRate * data[i].cid.classActualDuration /
                                        60)
                                        .toFixed(
                                            2);
                                } else {
                                    data[i].tid.teacherRatePayCNY =  (data[i].tid.teacherRate * data[i].cid.classActualDuration *
                                        rate / 60).toFixed(
                                            2);
                                }
                        }
                        this.list = data;

                        //导师查询后，对付款方式筛选， 筛选条件为支付宝
                        const teacherList = [];
                        for (let i = 0; i < this.list.length; i++) {
                            if (JSON.stringify(teacherList).indexOf((this.list[i].tid.teacherName)) == -1) {
                                if (this.list[i].tid.teacherPay == '支付宝')
                                    teacherList.push({
                                        teacherName: this.list[i].tid.teacherName,
                                        types: this.list[i].tid.types,
                                        price: 0,
                                        xinxi: this.list[i].tid.userInformation,
                                        fukuanfangshi: this.list[i].tid.teacherPay,
                                        name: this.list[i].tid.userName,
                                    });
                            }

                        }
                 
                        let sumCount = 0;
                        for (let i = 0; i < teacherList.length; i++) {
                            for (let c= 0; c < this.list.length; c++) {
                                if (teacherList[i].teacherName == this.list[c].tid.teacherName) {
                                    if (this.list[c].tid.teacherRatePayCNY != undefined) {
                                        teacherList[i].price += parseFloat(this.list[c].tid.teacherRatePayCNY);
                                        sumCount += parseFloat(this.list[c].tid.teacherRatePayCNY);
                                    }
                                }
                            }
                            teacherList[i].price = Number(parseFloat(String(teacherList[i].price)).toFixed(2));
                        }

                        this.sumCount = Number(parseFloat(String(sumCount)).toFixed(2));
                        this.teacherList = teacherList;
                    })
                })
            }

        /**
         * @description: 导师信息中的列拖拽方法
         * @return void
         */
        columnDrop(): void{
            const wrapperTr: any = document.querySelector('.el-table__header-wrapper tr');
            this.sortable = Sortable.create(wrapperTr, {
                animation: 180,
                delay: 0,
                onEnd: (evt: any) => {
                    const oldItem = this.dropCol[evt.oldIndex];
                    this.dropCol.splice(evt.oldIndex, 1);
                    this.dropCol.splice(evt.newIndex, 0, oldItem);
                    DataHelperSingleton.getInstance().savaData('ctrlcol',this.dropCol);
                }
            });
        }

        /**
         * @description: 生命周期 mounted挂载后
         * @return void
         */
        mounted() {
            //列属性   sortable
            this.columnDrop(); 
            this.onload();

            window.onresize = ()=>{this.tabelHeight = window.innerHeight;};
        }
        
        /**
         * @description: 生命周期 created实例创建完成
         * @return void
         */
        created(){
            //拖拽
            const dataHelper: DataHelperSingleton  = DataHelperSingleton.getInstance();
            if ( dataHelper.readData('ctrlcol').length>0)
            {
                this.Col=this.dropCol=dataHelper.readData('ctrlcol');
            }
        }
}
